// Bootstrap de Phaser: crea la instancia del juego y registra las escenas.

import Phaser from 'phaser';
import { GAME, HEX, PHYS } from './config';
import { getStudentPlaySession } from './systems/ProgressData';
import { BootScene } from './scenes/BootScene';
import { MenuScene } from './scenes/MenuScene';
import { GameModeScene } from './scenes/GameModeScene';
import { GalaxyScene } from './scenes/GalaxyScene';
import { ProfileScene } from './scenes/ProfileScene';
import { SumaMissionsScene } from './scenes/SumaMissionsScene';
import { RestaMissionsScene } from './scenes/RestaMissionsScene';
import { MultiplicacionMissionsScene } from './scenes/MultiplicacionMissionsScene';
import { DivisionMissionsScene } from './scenes/DivisionMissionsScene';
import { MissionScene } from './scenes/MissionScene';
import { LevelScene } from './scenes/LevelScene';
import { PracticeScene } from './scenes/PracticeScene';
import { PracticeHUDScene } from './scenes/PracticeHUDScene';
import { PracticeResultScene } from './scenes/PracticeResultScene';
import { HUDScene } from './scenes/HUDScene';
import { ResultScene } from './scenes/ResultScene';

export function createGame(parent, student) {
  const game = new Phaser.Game({
    callbacks: { preBoot: (instance) => {
      if (student) {
        let identity = student;
        try { identity = getStudentPlaySession(student.student_id).student; } catch { /* Gate supplies initial authenticated identity. */ }
        instance.registry.set('studentIdentity', { student_id: identity.student_id, alias: identity.alias, avatar: identity.avatar });
      }
    } },
    type: Phaser.AUTO,
    parent,
    backgroundColor: HEX.bgDeep,
    width: GAME.WIDTH,
    height: GAME.HEIGHT,
    scale: {
      mode: Phaser.Scale.RESIZE,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 1280,
      height: 720,
    },
    render: { pixelArt: false, antialias: true, roundPixels: true },
    fps: { target: 60 },
    input: { activePointers: 3 },
    physics: {
      default: 'arcade',
      arcade: { gravity: { y: PHYS.GRAVITY }, debug: false },
    },
    scene: [BootScene, MenuScene, GameModeScene, GalaxyScene, ProfileScene, SumaMissionsScene, RestaMissionsScene, MultiplicacionMissionsScene, DivisionMissionsScene, MissionScene, LevelScene, PracticeScene, PracticeHUDScene, HUDScene, ResultScene, PracticeResultScene],
  });
  if (typeof window !== 'undefined') {
    window.__TMAG_GAME = game;
    window.__TMAG_COUNT = (window.__TMAG_COUNT || 0) + 1;
  }
  // Evitar que Phaser congele el loop cuando la pestaña se marca como "oculta"
  // (necesario para automatización/headless; en uso real el juego sigue igual).
  game.events.once('ready', () => {
    if (game.loop) {
      game.loop.pause = () => {};
      game.loop.wake = game.loop.wake || (() => {});
    }
  });
  return game;
}
